<template>
  <v-text-field
    v-model="search"
    class="search-field"
    background-color="#EDEDED"
    color="primary"
    type="search"
    label="Buscar"
    append-icon="fas fa-search"
    clear-icon="fas fa-times"
    hide-details
    clearable
    outlined
    dense
  ></v-text-field>
</template>

<script>
import { productFilter } from "../../../utils/productFilter";

export default {
  mixins: [productFilter],
};
</script>

<style lang="scss" scoped>
.search-field::v-deep {
  fieldset {
    border: 0 !important;
  }
}
</style>
